import { z } from 'zod';

export const DeckFormatSchema = z.enum(['widescreen', 'standard']);
export type DeckFormat = z.infer<typeof DeckFormatSchema>;

// PowerPoint slide sizes at 144 DPI: widescreen 13.333in × 7.5in, standard 10in × 7.5in.
export const DECK_FORMAT_DIMENSIONS: Record<
  DeckFormat,
  { width: number; height: number }
> = {
  widescreen: { width: 1920, height: 1080 },
  standard: { width: 1440, height: 1080 },
};
